interface ISessionStackInstance {
  getSessionId: () => unknown;
  identify: () => unknown;
  isLoaded: boolean;
  log: (content: unknown) => void;
  q: unknown[];
  setOnDataCallback: () => unknown;
  start: () => unknown;
  stop: () => unknown;
  t: string;
}

export default class LoggingService {
  private sessionStackInstance: ISessionStackInstance | null = null;

  public setSessionStackInstance(sessionStackInstance: ISessionStackInstance): void {
    this.sessionStackInstance = sessionStackInstance;
  }

  private logToSessionStack(content: unknown): void {
    if(!this.sessionStackInstance) {
      return;
    }
    this.sessionStackInstance.log(content);
  }

  public log(options: { sessionStack?: boolean }, exceptionContent: unknown): void {
    if(options.sessionStack) {
      this.logToSessionStack(exceptionContent);
    }
  }
}
